/* eslint-disable react/prop-types */
/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import Hint, { HintContent } from '../Hint/Hint';
import InputContainer from '../InputContainer/InputContainer';
import Label from '../Label/Label';
import useTheme from '../style/useTheme';
import Typography from '../Typography/Typography';
import { noop } from '../utils';
import { SxProp } from '../style/sxProp';

type Props = React.PropsWithChildren<{
  label?: string;
  showRequiredAsterisk?: boolean;
  id: string;
  labelId?: string;
  eventId?: string;
  errorMessage?: string;
  errorId?: string;
  hint?: HintContent;
  hintId?: string;
  onHintToggle?: (open: boolean) => void;
  sx?: SxProp;
}>;

const InputControl: React.FC<Props> = ({
  label,
  labelId,
  showRequiredAsterisk,
  id,
  eventId,
  errorMessage,
  errorId,
  hint,
  hintId,
  onHintToggle = noop,
  children,
  sx,
}) => {
  const { theme } = useTheme();

  return (
    // TODO: also set data-testid
    <InputContainer sx={sx} id={id}>
      {label && (
        <Label
          label={label}
          showRequiredAsterisk={showRequiredAsterisk}
          id={labelId}
        />
      )}
      {children}
      <div
        id={errorId}
        data-testid={`${id}-error`}
        className="origami-ErrorMessage"
        hidden={!errorMessage}
        aria-hidden={!errorMessage}
      >
        <Typography
          variant="caption"
          color={{
            type: 'component',
            value: theme.components.input.default.errorMessageColor,
          }}
        >
          {errorMessage}
        </Typography>
      </div>
      <Hint
        hint={hint}
        id={hintId}
        onHintToggle={onHintToggle}
        eventId={eventId}
      />
    </InputContainer>
  );
};

export default InputControl;
